var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorkOutline = function SvgWorkOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M597.333 277.333V192H426.666v85.333zm-426.666 85.334V832h682.667V362.667zm682.666-85.334a85.04 85.04 0 0 1 85.333 85.333v469.333a85.04 85.04 0 0 1-85.333 85.333H170.666a85.04 85.04 0 0 1-85.333-85.333l.427-469.333c0-47.36 37.547-85.333 84.907-85.333h170.667V192a85.04 85.04 0 0 1 85.333-85.333h170.667A85.04 85.04 0 0 1 682.667 192v85.333z"
  })));
};
export default SvgWorkOutline;